import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'

import Box from '../components/Box';
import Flex from '../components/Flex';
import Button from '../components/Button';
import { Media, responsive } from '../contexts/responsive';
// import PostMenu from './PostMenu';

const menus = [
  {
    label: '合作洽詢',
    trackerName: 'header_collab',
    to: '/contact/'
  },
  {
    label: '品牌服務',
    trackerName: 'header_service',
    to: '/service/'
  },
  {
    label: '作品選集',
    trackerName: 'header_collection',
    to: '/portfolio/'
  },
  {
    label: '計畫基地',
    trackerName: 'header_guide',
    to: '/#guide'
  },
  {
    label: '團隊故事',
    trackerName: 'header_about',
    to: '/about/'
  },
  {
    label: '特輯列表',
    trackerName: 'header_article',
    to: '/articles/'
  },
  {
    label: '回到首頁',
    trackerName: 'header_backto',
    to: '/'
  },
]

const Menu = ({ isOpen, onClose, pathname, isSolid }) => {
  return (
    <Box>
      <Media greaterThanOrEqual='md'>
        <Flex alignItems={'center'}>
          {menus.map(({ label, to, trackerName, Element = Button.Transparent }, i) => {
            const isActive = pathname === to
            return (
              <Box borderLeft={i && '1px solid'} color={'custom.bgGray'} key={i}>
                <Element
                  trackerName={trackerName}
                  px="0.75em"
                  fontSize="1rem"
                  color={isSolid ? (isActive ? 'black' : 'custom.bgGray') : (isActive ? 'white' : 'whiteAlpha.700')}
                  to={to}
                  onClick={onClose}
                >{label}</Element>
              </Box>
            )
          })}
        </Flex>
      </Media>
      <Media lessThan='md'>
        <Drawer
          isOpen={isOpen}
          placement='right'
          onClose={onClose}
        >
          <DrawerContent style={{ width: 'auto' }}>
            <DrawerCloseButton />
            <DrawerBody pl="1em" pt="2.375em" pr="1.375em" boxShadow={'rgb(0 0 0 / 20%) -4px 0px 10px'}>
              {menus.map(({ label, to, trackerName, Element = Button.Transparent }, i) => (
                <Box borderTop={i && '1px solid'} borderColor="custom.bgGray" py="1em" key={i}>
                  <Element
                    pl="0.375rem"
                    pr="0.875rem"
                    fontSize={responsive('0.875em', '1em')}
                    trackerName={trackerName}
                    color={pathname === to ? 'black' : 'custom.bgGray'}
                    to={to}
                    onClick={onClose}
                  >{label}</Element>
                </Box>
              ))}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Media>
    </Box>
  );
};

export default Menu;
